import React from 'react';
import {Col, Row, Table} from 'antd';
import * as moment from "moment-timezone/index";
import _ from "lodash";

const ViewMeterReading = ({data, lastProcessedResource}) => {
  let meter = data && data['pm'] && data['pm']['meterReading'] || [];
  const {lastRecord: lastUnprocessedRecord, lastProcessedScheduleWise, lastProcessed} = lastProcessedResource || {};
  const {schedules} = data.pm || {};
  let lastMeter = []; //lastProcessedResource && lastProcessedResource['meterReading'] || [];
  (lastProcessedScheduleWise || []).map(async lp => {
    (lp.lastProcessed && lp.lastProcessed.meterReading || []).forEach(m => {
      m.schedule = lp.schedule;
      const sch = schedules && schedules.filter(sc => sc._id === lp.schedule);
      if(sch && sch.length) {
        m.scheduleName = sch[0].serviceIdentifierNo;
      }
    });
    lastMeter = lastMeter.concat(lp.lastProcessed && lp.lastProcessed.meterReading || []);
    // console.log(lp.lastProcessed && lp.lastProcessed.meterReading || [])
  });
  // console.log(lastProcessedScheduleWise, lastMeter);
  const date = (data && data['pm'] && data['pm']['processedOn']) || data && data['pm'] && data['pm']['createdAt'] || new Date();
  let timeIntervals = [];
  schedules && schedules.map(si => {
    timeIntervals = timeIntervals.concat(si.timeIntervals && si.timeIntervals.map(t => {
      return {
        ...t,
        ...{schedule: si.serviceIdentifierNo || '', scheduleId: si._id || null}
      }
    }) || []);
  });

  const allTimeIntervals = [...timeIntervals];
  timeIntervals = _.uniqWith(timeIntervals, (arrVal, othVal) => (arrVal.name === othVal.name));

  // const timeIntervals = schedules && schedules.timeIntervals || [];
  if(!meter.length) {
    timeIntervals.map(interval => {
      schedules && schedules.map(si => {
        meter.push({name: interval.name, value: 0, schedule: si._id, scheduleNo: si.serviceIdentifierNo})
      });
    });
  }
  if(!lastMeter.length) {
    timeIntervals.map(interval => {
      schedules && schedules.map(si => {
        lastMeter.push({name: interval.name, value: 0, schedule: si._id, scheduleNo: si.serviceIdentifierNo});
      });
    });
  }
  // console.log(lastMeter);

  const nextMeter = allTimeIntervals.map(interval => {
    const currentMeter = meter.filter(read => read.name === interval.name && interval.scheduleId === read.schedule);
    if(currentMeter && currentMeter.length) {
      if(interval.name === 'KM' || interval.name === 'HOUR') {
        return {
          value: (currentMeter[0].value > 0 ? currentMeter[0].value : interval.value) + interval.value,
          name: `${interval.name} (${interval.schedule})`
        };
      } else {
        // console.log(date);
        return {
          value: moment(date).add(interval.value,
            `${interval.name.toLowerCase()}s`).format('DD-MM-YYYY'),
          name: `${interval.name} (${interval.schedule})`
        };
      }
    } else {
      return {
        value: 0,
        name: `${interval.name} (${interval.schedule})`,
      }
    }
  });

  return (
    <div>
      <Row>
        <Col span={8}>
          <Table title={() => 'Last Reading'} size={'small'} bordered
                 pagination={false} dataSource={lastMeter} columns={[{
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (_, record) => `${record.name} (${record.scheduleNo || ''})`
          }, {
            title: 'Reading',
            dataIndex: 'value',
            key: 'value',
          }]} rowKey={(record) => record.name + record.value + record.schedule}/>
        </Col>
        <Col span={8}>
          <Table title={() => 'Current Reading'} size={'small'} bordered
                 pagination={false} dataSource={meter} columns={[{
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (_, record) => `${record.name} (${record.scheduleNo || ''})`
          }, {
            title: 'Reading',
            dataIndex: 'value',
            key: 'value',
          }]} rowKey={(record) => record.name + record.value + record.schedule}/>
        </Col>
        <Col span={8}>
          <Table title={() => 'Next Reading'} size={'small'} bordered
                 pagination={false} dataSource={nextMeter} columns={[{
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
          }, {
            title: 'Reading',
            dataIndex: 'value',
            key: 'value',
          }]} rowKey={(record) => record.name + record.value}/>
        </Col>
      </Row>
    </div>
  );
};

export default ViewMeterReading;
